export const EVENT_TYPE_BROADCAST = 1 
export const EVENT_TYPE_INTERACTIVE = 0
export const streamingTypes = [ {str_description:"Interactive", event_type:EVENT_TYPE_INTERACTIVE},
 {str_description:"Broadcast", event_type:EVENT_TYPE_BROADCAST}]
